module.exports = __webpack_public_path__ + "static/media/om_beard_stubble_round_darkbrown.3935343b.png";